<template>
  <div v-if="!traffic" class="placeholder">
    <img src="https://bvg-cdn.de/logos/bvg-herz_outline.svg" alt="BVG Logo" />
  </div>
  <div v-else class="container">
    <main>
      <section v-for="(chunks, ii) in getTrafficData" :key="ii">
        <LinienBox v-for="(data, jj) in chunks" :key="jj" :data="data" />
      </section>
    </main>
  </div>

  <footer>
    <div class="sysinfo">
      <span
        >&copy; {{ new Date().getFullYear() }} Berliner Verkehrsbetriebe
        (BVG)</span
      >
      <span>Version {{ APP_VERSION }}</span>
      <span v-if="trafficUpdatedAt">{{ formattedTrafficUpdatedAt }}</span>
    </div>
    <div v-if="clockElement" id="clock">{{ clockElement }}</div>
  </footer>
</template>

<script>
import LinienBox from './components/LinienBox.vue';
// import QRCodeBox from './components/QRCodeBox.vue';

export default {
  components: {
    LinienBox,
    // QRCodeBox,
  },
  data() {
    return {
      // eslint-disable-next-line no-undef
      APP_VERSION: __APP_VERSION__,
      timer: null,
      clockElement: null,

      traffic: [],
      trafficUpdatedAt: null,
      disruptions: [],

      socket: null,
      errorReport: null,
    };
  },
  computed: {
    getTrafficData() {
      const trafficData = Object.values(this.traffic);
      const disruptionData = Object.values(this.disruptions);

      const chunks = new Map();
      trafficData.forEach((t) => {
        if (!chunks.has(t.profile)) {
          chunks.set(t.profile, []);
        }

        const lowerLine = t.lineTxt.toLowerCase();
        const hasDisruption = disruptionData.some((d) => d.line === lowerLine);

        chunks.get(t.profile).push({ ...t, hasDisruption });
      });

      return Array.from(chunks.values());
    },
    formattedTrafficUpdatedAt() {
      const date = new Date(this.trafficUpdatedAt);
      return new Intl.DateTimeFormat('de-DE', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        timeZoneName: 'short',
      }).format(date);
    },
  },
  mounted() {
    // this.clock();
    this.connectWebsocket();
  },
  beforeUnmount() {
    this.socket?.close();
  },
  methods: {
    connectWebsocket() {
      this.socket = new WebSocket('wss://api.bvg-fgi.de/v2/');

      this.socket.onopen = () => {
        this.websocketSubscribeTo('traffic-symbols');
        this.websocketSubscribeTo('disruptions');
      };

      this.socket.onmessage = (event) => {
        const msg = JSON.parse(event.data);

        if (msg.type === 'data-update' || msg.type === 'last-data') {
          if (msg.channel === 'traffic-symbols') {
            this.loadTraffic(msg);
          }
          if (msg.channel === 'disruptions') {
            this.loadDisruptions(msg);
          }
        }
      };

      this.socket.onclose = () => {
        setTimeout(this.connectWebsocket, 1 * 60 * 1000);
      };
    },
    websocketSubscribeTo(channel) {
      this.socket.send(JSON.stringify({ type: 'subscribe', channel }));
    },
    loadTraffic(data) {
      this.traffic = data.data;
      this.trafficUpdatedAt = data.updatedAt;
    },
    loadDisruptions(msg) {
      const data = msg.data.filter(
        (d) => d.type !== null && d.type !== 'Kein Halt'
      );
      this.disruptions = data;
    },
    clock() {
      const date = new Date();
      let h = date.getHours();
      let m = date.getMinutes();

      h = h < 10 ? `0${h}` : h;
      m = m < 10 ? `0${m}` : m;

      this.clockElement = `${h}:${m}`;

      setTimeout(this.clock, 1000);
    },
    cancelAutoUpdate() {
      clearInterval(this.timer);
    },
  },
};
</script>

<style scoped>
.placeholder,
.container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  width: 100vw;
}

.placeholder {
  background-color: var(--bvg-color);
}

.placeholder > img {
  max-height: 60%;
  max-width: 60%;
}

main {
  display: flex;
  /* gap: var(--grid-vertical); */
  flex-direction: column;
  align-items: center;

  height: 100%;
  width: 100%;
}
main > section {
  flex: 1 1 100%;
  display: flex;
  align-items: center;
  gap: var(--grid-horizontal);
  padding: 1rem;
}

footer {
  position: fixed;
  left: 0;
  bottom: 0;

  width: 100%;

  display: flex;
  align-items: flex-end;
  justify-content: space-between;
}
footer > .sysinfo {
  display: flex;
  gap: 0.5rem;
  font-size: 0.35rem;
  padding: 0.15rem;
  color: rgba(0, 0, 0, 0.3);
}
footer > #clock {
  line-height: 0.85;
  font-weight: 600;
  font-size: var(--footer-size);
  padding: 0 var(--footer-right) var(--footer-bottom) 0;
}

@media (max-width: 800px) {
  .container {
    display: block;
    height: auto;
  }

  main {
    padding: 1rem 0;
    /* gap: 1rem; */
  }

  main > section {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 1rem;
    padding: 0.5rem;
  }

  footer {
    position: static;
  }
}
</style>
